import { http } from '@pendo/http';

export function fetchWebhooks () {
    return http.get('/api/s/_SID_/webhook?new=true');
}

export function fetchWebhook ({ id }) {
    return http.get(`/api/s/_SID_/webhook/${id}?new=true`);
}

export function updateWebhook ({ webhook }) {
    return http.put(`/api/s/_SID_/webhook/${webhook.id}`, webhook);
}

export function createWebhook ({ webhook }) {
    return http.post('/api/s/_SID_/webhook', webhook);
}

export function deleteWebhook ({ id }) {
    return http.delete(`/api/s/_SID_/webhook/${id}`);
}

export function pingWebhook (payload) {
    return http.post('/api/s/_SID_/webhook/ping', payload);
}

export function fetchWebhookErrorLogs ({ id }) {
    return http.get(`/api/s/_SID_/webhook/${id}/logs/error`);
}
